var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8631 7.88171L3.88085 7.89537L9.8983 1.9406C10.0083 1.83717 10.0963 1.713 10.157 1.5754C10.2178 1.4378 10.2501 1.28955 10.252 1.1394C10.254 0.989253 10.2255 0.840238 10.1683 0.701142C10.1112 0.562046 10.0264 0.435686 9.91915 0.329506C9.81185 0.223326 9.68416 0.139477 9.5436 0.0829016C9.40304 0.0263266 9.25245 -0.00183018 9.10072 9.21997e-05C8.94899 0.00201458 8.79919 0.0339764 8.66014 0.094094C8.52109 0.154212 8.39561 0.241268 8.29109 0.350131L0.333198 8.22513C0.12016 8.43609 0.000488281 8.72213 0.000488281 9.02037C0.000488281 9.31861 0.12016 9.60464 0.333198 9.8156L8.29109 17.6906C8.50602 17.8927 8.79222 18.0037 9.08867 17.9999C9.38511 17.9962 9.66835 17.8779 9.87798 17.6705C10.0876 17.463 10.2071 17.1828 10.2109 16.8894C10.2147 16.596 10.1025 16.3128 9.8983 16.1001L3.88085 10.1454L22.8631 10.1317C23.1646 10.1317 23.4538 10.0132 23.667 9.80221C23.8802 9.59123 23.9999 9.30508 23.9999 9.00671C23.9999 8.70835 23.8802 8.4222 23.667 8.21122C23.4538 8.00024 23.1646 7.88171 22.8631 7.88171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.4b747743d070b4e491b925c1471a429a.svg";
export { ForwardRef as ReactComponent };